import { render, staticRenderFns } from "./TrainingModeModal.vue?vue&type=template&id=04d0b2bc"
import script from "./TrainingModeModal.vue?vue&type=script&lang=js"
export * from "./TrainingModeModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingModeModal.vue?vue&type=style&index=0&id=04d0b2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports